import ChannelMenu, { type ScopeNode } from "@/components/ChannelMenu"
import Inline from "./Inline"

interface Props {
  scopeTree: ScopeNode[]
  scope: { id: string; name: string }
  hrefForScope: (slug: string) => string
  categoryTree: ScopeNode[]
  category: { id: string; name: string } | null
  hrefForCategory: (slug: string) => string
}

// Overview's Scope and Category, inline in its section bar.
export default function PageFilters(props: Props) {
  return (
    <div className="flex items-center gap-5">
      <Inline label="Scope">
        <ChannelMenu
          scopeTree={props.scopeTree}
          currentNodeId={props.scope.id}
          currentNodeName={props.scope.name}
          hrefForChannel={props.hrefForScope}
          requireLeaf={false}
        />
      </Inline>
      <Inline label="Category">
        <ChannelMenu
          scopeTree={props.categoryTree}
          currentNodeId={props.category?.id ?? "all"}
          currentNodeName={props.category?.name ?? "All categories"}
          hrefForChannel={props.hrefForCategory}
          requireLeaf={false}
          label="Category"
        />
      </Inline>
    </div>
  )
}
